export interface UserProfile {
  id: string;
  nickname: string;
  avatar: string;
  bio: string;
  location: string;
  worksCount: number;
  fansCount: number;
}

export const users: UserProfile[] = [
  {
    id: 'u01',
    nickname: '阿木在拍',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20avatar%20of%20young%20asian%20male%20photographer%20with%20camera%2C%20warm%20studio%20background%2C%20friendly%20smile%2C%20editorial%20headshot%20style&width=200&height=200&seq=avatar-u01&orientation=squarish',
    bio: '人像摄影师，喜欢用光影讲故事，常驻上海。',
    location: '上海',
    worksCount: 86,
    fansCount: 12400,
  },
  {
    id: 'u02',
    nickname: '晚风与橘',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20avatar%20of%20young%20asian%20female%20photographer%2C%20warm%20orange%20toned%20background%2C%20confident%20smile%2C%20editorial%20headshot%20style&width=200&height=200&seq=avatar-u02&orientation=squarish',
    bio: '风光摄影爱好者，走过100座山，还在路上。',
    location: '成都',
    worksCount: 54,
    fansCount: 8600,
  },
  {
    id: 'u03',
    nickname: '微观大叔',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20avatar%20of%20middle%20aged%20asian%20man%20with%20glasses%2C%20warm%20studio%20lighting%2C%20calm%20expression%2C%20editorial%20headshot%20style&width=200&height=200&seq=avatar-u03&orientation=squarish',
    bio: '微距摄影十年，专注昆虫与露珠的微观世界。',
    location: '杭州',
    worksCount: 132,
    fansCount: 21300,
  },
  {
    id: 'u04',
    nickname: '不正经摄影',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20avatar%20of%20creative%20young%20asian%20artist%20with%20colorful%20style%2C%20warm%20background%2C%20playful%20expression%2C%20editorial%20headshot&width=200&height=200&seq=avatar-u04&orientation=squarish',
    bio: '创意摄影是我的游乐场，欢迎来玩。',
    location: '北京',
    worksCount: 68,
    fansCount: 15700,
  },
  {
    id: 'u05',
    nickname: '街角观察员',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20avatar%20of%20asian%20male%20street%20photographer%20wearing%20cap%2C%20warm%20urban%20background%2C%20editorial%20headshot%20style&width=200&height=200&seq=avatar-u05&orientation=squarish',
    bio: '记录城市里普通人的高光时刻。',
    location: '广州',
    worksCount: 97,
    fansCount: 9900,
  },
  {
    id: 'u06',
    nickname: '夜游神',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20avatar%20of%20asian%20female%20night%20photographer%2C%20neon%20warm%20orange%20lighting%2C%20cool%20confident%20expression%2C%20editorial%20headshot&width=200&height=200&seq=avatar-u06&orientation=squarish',
    bio: '白天睡觉，晚上拍星星和霓虹灯。',
    location: '重庆',
    worksCount: 45,
    fansCount: 7200,
  },
];

export const getUserById = (id: string) => users.find((u) => u.id === id);